// Per-panel visibility — finer than the per-topNav `canSee`. Used to keep the
// Quant vs Maker groups isolated under the shared `trader` tab. Kept as a leaf
// module (imports registry types + roles values) to avoid an import cycle.

import type { PanelDef } from '../panels/registry';
import { usesWebSocket, type Role } from './roles';

/// Whether `role` may see this panel: the `requiresWs` gate (excludes `user`)
/// plus the optional per-panel `roles` allowlist.
export function canSeePanel(panel: PanelDef, role: Role | null | undefined): boolean {
  if (panel.requiresWs && !usesWebSocket(role)) return false;
  if (panel.roles && !(role && panel.roles.includes(role))) return false;
  return true;
}

/// The subset of `panels` this role may see, order preserved.
export function visibleSidebar(panels: PanelDef[], role: Role | null | undefined): PanelDef[] {
  return panels.filter((panel) => canSeePanel(panel, role));
}
